// src/pages/AddType.js
import React, { useEffect, useState } from "react";
import { useAuthCheck } from "../components/Auth";
import { useNavigate } from "react-router-dom";
import { api } from "../components/Api";
import Loading from "../components/Loading";

export default function AddType() {
    const [form, setForm] = useState({
        type_name: "",
        type_ref: "",
    });
    const [existingRefs, setExistingRefs] = useState([]);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();
    const { checkToken } = useAuthCheck();

    useEffect(() => { checkToken(); }, [checkToken]);

    useEffect(() => {
        const fetchTypes = async () => {
            setLoading(true);
            try {
                const res = await api.get("/types");
                const refs = res.data.map(t => t.type_ref);
                setExistingRefs(refs);
            } catch (err) {
                console.error(err);
                alert("Erreur lors de la récupération des types existants.");
            } finally {
                setLoading(false);
            }
        };
        fetchTypes();
    }, []);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setForm(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        let { type_name, type_ref } = form;

        // Convertir la référence en majuscule
        type_ref = type_ref.toUpperCase();

        // Vérifications front
        if (!type_name.trim()) {
            return alert("Le nom du type est obligatoire.");
        }

        if (!type_ref.match(/^[A-WY-Z]$/)) {
            return alert(
                "La référence doit être une seule lettre. X n’est pas autorisée."
            );
        }

        if (existingRefs.includes(type_ref)) {
            return alert("Cette lettre de référence est déjà utilisée.");
        }

        try {
            await api.post("/types", { type_name, type_ref });
            alert("Type ajouté avec succès !");
            navigate("/type-list");
        } catch (err) {
            console.error(err);
            alert("Erreur lors de l'ajout du type.");
        }
    };

    const token = localStorage.getItem("token");

    if (!token || localStorage.getItem("role") > 2) {
        navigate("/");
    }

    if (loading) return <Loading message="Chargement..." />;

    return (
        <div className="container mx-auto p-6 max-w-md">
            <h1 className="text-2xl font-bold mb-4 dark:text-white">Ajouter un Type</h1>
            <form onSubmit={handleSubmit} className="space-y-4">
                <div>
                    <label htmlFor="type_name" className="block font-medium mb-1">
                        Nom du type
                    </label>
                    <input
                        type="text"
                        id="type_name"
                        name="type_name"
                        value={form.type_name}
                        onChange={handleChange}
                        className="w-full border p-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-400 dark:bg-gray-700 bg-white"
                        required
                    />
                </div>

                <div>
                    <label htmlFor="type_ref" className="block font-medium mb-1">
                        Référence (1 lettre)
                    </label>
                    <input
                        type="text"
                        id="type_ref"
                        name="type_ref"
                        value={form.type_ref}
                        onChange={handleChange}
                        maxLength={1}
                        className="w-full border p-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-400 dark:bg-gray-700 bg-white"
                        required
                    />
                    <p className="text-sm text-gray-500 mt-1">
                        Une lettre non utilisée, X interdite.
                    </p>
                </div>

                <button
                    type="submit"
                    className="bg-blue-500 hover:bg-blue-600 text-white font-semibold px-4 py-2 rounded"
                >
                    Ajouter
                </button>
            </form>
        </div>
    );
}
